<template>
  <div>
    <v-progress-linear
      :active="loading"
      :indeterminate="loading"
      absolute
      top
    ></v-progress-linear>

    <v-breadcrumbs class="pa-4" :items="breadcrumb" large></v-breadcrumbs>

    <v-card class="ma-1" v-if="params">
      <v-card-title>{{ params.accountName }}</v-card-title>

      <v-card-subtitle class="pb-1">
        <span v-if="!loading">{{ total() > 1 ? `${total()} locais serão atualizados` : `${total()} local será atualizado` }}</span>
        <v-progress-circular
            v-else
            :size="20"
            class="mx-auto my-auto"
            indeterminate
            color="primary"
        ></v-progress-circular>
      </v-card-subtitle>

      <div class="mx-4 mb-4 my-2">
        <v-chip small class="mx-1 my-1" v-if="params.accountName && params.account">Conta: {{ params.accountName }}</v-chip>
        <v-chip small class="mx-1 my-1" v-for="(city, key) in params.city" :key="key">Cidade: {{ city }}</v-chip>
        <v-chip small class="mx-1 my-1" v-for="(state, key) in params.state" :key="key">Estado: {{ state }}</v-chip>
        <v-chip small class="mx-1 my-1" v-if="params.allSelected > 0 && params.ids && params.ids.length > 0">
          Todos os locais foram selecionados, exceto: {{ params.ids.join(', ') }}
        </v-chip>
        <v-chip small class="mx-1" v-if="!params.allSelected > 0 && params.ids && params.ids.length > 0">
          Somente os locais com os ids: {{ params.ids.join(', ') }}
        </v-chip>
      </div>

      <v-tabs show-arrows v-model="tab" class="mb-4">
        <v-tab
          v-for="tab in tabs"
          :key="tab.name"
          :disabled="!dataIsValid || tab.disabled || (tab.name === 'publications' && !canMangeLocalPostsTag)"
        >
          {{ tab.title }}
        </v-tab>
      </v-tabs>
    </v-card>

    <div v-if="!dataIsValid" class="ma-0 pa-1">
      Parâmetros incompletos, volte a lista de locais e tente novamente.
    </div>

    <v-tabs-items v-else-if="params" v-model="tab">
      <v-tab-item class="ma-0 pa-1" v-if="params.action === locationConstants.UPDATE_LOCATION">
        <location-info-bulk-update-tab
          :allSelected="params.allSelected"
          :ids="params.ids"
          :account="params.account"
          :total="total()"
          :filters="{ search: params.search, city: params.city, state: params.state }"
        />
      </v-tab-item>

      <v-tab-item class="ma-0 pa-1" v-else-if="(params.action === locationConstants.UPDATE_LOCAL_POST || params.action === locationConstants.CREATE_LOCAL_POST)">
        <location-posts-bulk-tab
            :allSelected="params.allSelected"
            :ids="params.ids"
            :account="params.account"
            :total="total()"
            :type-action="params.action"
            :filters="{ search: params.search, city: params.city, state: params.state }"
        />
      </v-tab-item>

      <v-tab-item class="ma-0 pa-1">
        <location-list-tab
            :ids="params.ids"
            :all-selected="params.allSelected"
            :account="params.account"
            :filters="{ search: params.search, city: params.city, state: params.state }"
        />
      </v-tab-item>
      <v-tab-item v-if="params" class="ma-0 pa-1">
        <location-photos-tab
            :locationData="params"
            :bulk="true"
            :filters="{ search: params.search, city: params.city, state: params.state }"
        />
      </v-tab-item>
    </v-tabs-items>

    <v-snackbar v-model="snackbar.show" timeout="3000" :color="snackbar.color">
      {{ snackbar.text }}
      <template v-slot:action="{ attrs }">
        <v-btn text v-bind="attrs" @click="snackbar.show = false">
          Ok
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import LocationInfoBulkUpdateTab from '@/views/Locations/Tabs/LocationInfoBulkUpdateTab';
import hasPermission from '@/helpers/hasPermission';
import * as permissionsNames from '@/constants/permissions';
import * as locationConstants from '@/constants/locations';
import LocationListTab from '@/views/Locations/Tabs/LocationListTab';
import LocationPostsBulkTab from '@/views/Locations/Tabs/LocationPostsBulkTab';
import LocationPhotosTab from '@/views/Locations/Tabs/LocationPhotosTab';
import {handleResponseError} from '@/api/handleError'

export default {
  name: 'LocationBulk',
  computed: {
    ...mapState({
      location: (state) => state.locations.location,
      locations: (state) => state.locations.all,
    }),
    canMangeLocalPostsTag() {
      return hasPermission(permissionsNames.CAN_MANAGE_LOCAL_POSTS);
    },
    locationConstants() {
      return locationConstants
    }
  },
  components: {
    LocationInfoBulkUpdateTab,
    LocationPostsBulkTab,
    LocationListTab,
    LocationPhotosTab,
  },
  mounted() {
    this.initData()
  },
  created() {
    this.$store.dispatch('locations/clearLocation')
  },
  beforeDestroy() {
    this.$store.dispatch('locations/clearFoodMenu')
  },
  destroyed() {
    this.$store.dispatch('locations/clearLocations')
  },
  data() {
    return {
      id: '',
      params: null,
      loading: false,
      breadcrumb: [
        {
          text: 'Locais',
          disabled: false,
          href: '/locations'
        },
        {
          text: 'Atualização em massa',
          disabled: true,
          href: ''
        }
      ],
      tab: null,
      tabs: [
          { id: 1, title: 'Informações', name: 'info' },
          { id: 2, title: 'Lista de locais', name: 'location-list' },
          { id: 3, title: 'Fotos', name: 'location-photos' }
      ],
      snackbar: {
        text: '',
        show: false,
        color: 'info'
      },
      locationsData: null,
      dataIsValid: false,
    };
  },
  methods: {
    showNotification(message, color) {
      this.snackbar.text = message
      this.snackbar.show = true
      this.snackbar.color = color
    },
    handleDataIsValid() {
      if (!this.params.account) {
        return this.dataIsValid = false
      }
      if (!this.params.action) {
        return this.dataIsValid = false
      }
      return this.dataIsValid = true
    },
    fetchLocations() {
      if (!this.dataIsValid) {
        return
      }
      const filters = {
        params: {
          ids: this.params.ids,
          allSelected: this.params.allSelected,
          account: this.params.account,
        },
        account: this.params.account,
        state: this.params.state,
        city: this.params.city,
        search: this.params.search,
      }

      this.loading = true
      this.$store.dispatch('locations/getLocations', filters).then(()=> {
        this.loading = false
      }).catch(e => {
        const message = handleResponseError(e, 'Ocorreu um erro ao buscar os locais.')
        this.showNotification(message, 'red darken-2')
        this.loading = false
      })
    },
    initData() {
      const url = new URL(window.location.href)
      const params = new URLSearchParams(url.search)
      const tab = params.get('tab')
      this.tab = this.tabs.findIndex((t) => t.name === tab)
      this.params = this.$route.params

      if(this.params.action && this.params.action !== 'UPDATE_LOCATION') {
        this.tabs.splice(2, 1)
      }

      this.handleDataIsValid();
      this.fetchLocations();
    },
    total() {
      return this.locations && this.locations.meta ? this.locations.meta.total : 0
    }
  }
};
</script>
